/* eslint-disable import/no-anonymous-default-export */

import DepartmentActionTypes from "./department.types";
import { docodeHexResponse } from "../../_common/common.utils";

const INITIAL_STATE = {
  addDepartmentDetailsResponse: null,
  updateDepartmentDetailsResponse: null,
  getDepartmentListResponse: null,
  getDepartmentListArr: [],
  fetchDepartmentDetailsResponse: null,
  fetchDepartmentDetailsArr: [],
  deleteDepartmentDetailsResponse: null,
};

export default (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    /** ***************** ADD Department DETAILS START *********************** */
    case DepartmentActionTypes.ADD_DEPARTMENT_DETAILS_SUCCESS:
      return { ...state, addDepartmentDetailsResponse: action.payload };

    case DepartmentActionTypes.ADD_DEPARTMENT_DETAILS_FAILURE:
      return { ...state, addDepartmentDetailsResponse: action.payload };

    case DepartmentActionTypes.ADD_DEPARTMENT_DETAILS_RESPONSE_CHANGED:
      return { ...state, addDepartmentDetailsResponse: null };
    /** ***************** ADD Department DETAILS END *********************** */

    /** ***************** UPDATE Department DETAILS START *********************** */
    case DepartmentActionTypes.UPDATE_DEPARTMENT_DETAILS_SUCCESS:
      return { ...state, updateDepartmentDetailsResponse: action.payload };

    case DepartmentActionTypes.UPDATE_DEPARTMENT_DETAILS_FAILURE:
      return { ...state, updateDepartmentDetailsResponse: action.payload };

    case DepartmentActionTypes.UPDATE_DEPARTMENT_DETAILS_RESPONSE_CHANGED:
      return { ...state, updateDepartmentDetailsResponse: null };
    /** ***************** UPDATE Department DETAILS END *********************** */

    /** ***************** GET Department DETAILS START *********************** */
    case DepartmentActionTypes.GET_DEPARTMENT_LIST_SUCCESS:
      return {
        ...state,
        getDepartmentListResponse: action.payload,
        getDepartmentListArr: docodeHexResponse(
          action.payload,
          "GetAllDepartmentPaginationKey",
        ),
      };

    case DepartmentActionTypes.GET_DEPARTMENT_LIST_FAILURE:
      return {
        ...state,
        getDepartmentListResponse: action.payload,
        getDepartmentListArr: [],
      };

    case DepartmentActionTypes.GET_DEPARTMENT_LIST_RESPONSE_CHANGED:
      return { ...state, getDepartmentListResponse: null };
    /** ***************** GET Department DETAILS END *********************** */

    /** ***************** FETCH Department DETAILS START *********************** */
    case DepartmentActionTypes.FETCH_DEPARTMENT_DETAILS_SUCCESS:
      return {
        ...state,
        fetchDepartmentDetailsResponse: action.payload,
        fetchDepartmentDetailsArr: docodeHexResponse(
          action.payload,
          "GetDepartmentKey",
        ),
      };

    case DepartmentActionTypes.FETCH_DEPARTMENT_DETAILS_FAILURE:
      return { ...state, fetchDepartmentDetailsResponse: action.payload };

    case DepartmentActionTypes.FETCH_DEPARTMENT_DETAILS_RESPONSE_CHANGED:
      return {
        ...state,
        fetchDepartmentDetailsResponse: null,
        fetchDepartmentDetailsArr: [],
      };
    /** ***************** FETCH Department DETAILS END *********************** */

    /** ***************** DELETE Department DETAILS START *********************** */
    case DepartmentActionTypes.DELETE_DEPARTMENT_DETAILS_SUCCESS:
      return { ...state, deleteDepartmentDetailsResponse: action.payload };

    case DepartmentActionTypes.DELETE_DEPARTMENT_DETAILS_FAILURE:
      return { ...state, deleteDepartmentDetailsResponse: action.payload };

    case DepartmentActionTypes.DELETE_DEPARTMENT_DETAILS_RESPONSE_CHANGED:
      return { ...state, deleteDepartmentDetailsResponse: null };
    /** ***************** DELETE Department DETAILS END *********************** */

    default:
      return state;
  }
};
